module.exports = __webpack_public_path__ + "img/Weapon_38.47c373b9.png";